export enum recruitmentsCopyTypes {
  FETCH_RECRUIMENTS_COPY_REQUEST = "FETCH_RECRUIMENTS_COPY_REQUEST",
  FETCH_RECRUIMENTS_COPY_SUCCESS = "FETCH_RECRUIMENTS_COPY_SUCCESS",
  FETCH_RECRUIMENTS_COPY_FAILURE = "FETCH_RECRUIMENTS_COPY_FAILURE",
}